import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, Mail } from "lucide-react";
import { COMPANY } from "../data/site";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#E2E8F0]"
    >
      {/* Top utility bar */}
      <div className="hidden md:block bg-[#0A192F] text-white text-xs">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center justify-between py-2">
          <div className="font-medium tracking-wide uppercase">
            Davangere, Karnataka · Industrial Spares Specialist
          </div>
          <div className="flex items-center gap-5">
            <a href={COMPANY.phoneHref} className="flex items-center gap-1.5 hover:text-[#0EA5E9]" data-testid="header-phone">
              <Phone size={12} /> {COMPANY.phone}
            </a>
            <a href={COMPANY.emailHref} className="flex items-center gap-1.5 hover:text-[#0EA5E9]" data-testid="header-email">
              <Mail size={12} /> {COMPANY.email}
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
            <img
              src="/images/logo/kie-logo-sky.png"
              alt="KIE — Kashetter Industrial Essentials"
              className="h-11 w-11 object-contain"
            />
            <img
              src="/images/logo/kie-eng-trans.png"
              alt="Sri Kashetter Industrial Essentials"
              className="hidden sm:block h-9 object-contain"
            />
            <div className="sm:hidden leading-tight">
              <div className="font-head font-black text-[#0A192F] text-base tracking-tight">
                KASHETTER
              </div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#475569] font-semibold">
                Industrial Essentials
              </div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `nav-link font-medium text-sm uppercase tracking-[0.15em] ${
                    isActive ? "text-[#0EA5E9] active" : "text-[#0A192F] hover:text-[#0EA5E9]"
                  }`
                }
                data-testid={`nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:block">
            <Link
              to="/enquiry"
              className="bg-[#0EA5E9] text-white px-5 py-3 font-bold text-xs uppercase tracking-[0.18em] hover:bg-[#0284C7] transition-colors"
              data-testid="header-cta-quote"
            >
              Get Quote
            </Link>
          </div>

          <button
            className="md:hidden p-2 text-[#0A192F]"
            onClick={() => setOpen((s) => !s)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E2E8F0] bg-white">
          <nav className="px-4 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `py-2 font-semibold text-sm uppercase tracking-[0.15em] ${
                    isActive ? "text-[#0EA5E9]" : "text-[#0A192F]"
                  }`
                }
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/enquiry"
              className="bg-[#0EA5E9] text-white px-5 py-3 text-center font-bold text-xs uppercase tracking-[0.18em]"
              data-testid="mobile-cta-quote"
            >
              Get Quote
            </Link>
            <div className="pt-3 border-t border-[#E2E8F0] text-xs text-[#475569] space-y-1">
              <a href={COMPANY.phoneHref} className="flex items-center gap-1.5"><Phone size={12} /> {COMPANY.phone}</a>
              <a href={COMPANY.emailHref} className="flex items-center gap-1.5"><Mail size={12} /> {COMPANY.email}</a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
